import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth/AuthContext";
import { RootPage } from "./routes/RootPage";
import { JoinPage } from "./routes/JoinPage";
import { OwnerPage } from "./routes/OwnerPage";
import { NotFoundPage } from "./routes/NotFoundPage";

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootPage />} />
          <Route path="/join/:slug" element={<JoinPage />} />
          <Route path="/owner" element={<OwnerPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
